import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { ALL_COMPLAINT } from "../../../api/allApi_List";
import ComplaintListContent from "../components/complaintList/ComplaintListContent";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import useFetchData from "../../../CustomHooks/useAxios/useFetchData";
import { setData, setCopyData } from "../../../redux/dataSlice";

const ComplaintsPage = () => {
  const { isLoaded } = useFetchData(ALL_COMPLAINT);
  const data = useSelector((state) => state.data.data);
  const error = useSelector((state) => state.data.error);
  const errMsg = useSelector((state) => state.data.errMessage);
  const dataLength = isLoaded && !errMsg ? data.length : 0;
  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoaded && !error) {
      const formattedComplaints = data.map((cp) => ({
        ...cp,
        isVisited: cp.visitIdList?.length > 0 ? 1 : 0,
      }));

      dispatch(setData(formattedComplaints));
      dispatch(setCopyData(formattedComplaints));
    }
  }, [isLoaded, error]);

  return (
    <MainPageLayout
      headerConfig={{ title: "Complaints" }}
      numberOfData={dataLength}
    >
      {isLoaded && !error ? (
        <ComplaintListContent complaintsData={data} />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(errMsg)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default ComplaintsPage;
